import { createRouter, createWebHistory } from 'vue-router'
import LandingPage          from '@/views/LandingPage.vue'
import RegistroPeleadorTour from '@/components/Torneo/RegistroPeleador.vue'
import AOS                  from "@/assets/vendor/aos/aos.js"
import Informacion          from '@/components/Informacion.vue'
import Peleadores           from '@/components/Peleadores.vue'
import Patrocinadores       from '@/components/Patrocinadores.vue'
import Contacto             from '@/components/Contact.vue'
import TorneoBrackets       from '@/components/Torneo/TorneoBrackets.vue'
import LoginJueces          from '@/components/Evento/LoginEvento.vue'
import TatamiView           from '@/components/Evento/TatamiView.vue'
import PantallaTatami       from '@/components/Evento/Publico/PantallaTatami.vue'
import ProximaPeleaEnVivo   from '@/components/Evento/Publico/ProximasPeleas.vue'

import Boletos          from '@/components/Evento-Julio/Boletos.vue'
import BoletoAsignado   from '@/components/Evento-Julio/Boletos/BoletoAsignado.vue'
import Categorias       from '@/components/Evento-Julio/Categorias.vue'
import ComprarBoletos   from '@/components/Evento-Julio/Boletos/ComprarBoletos.vue'
import RegistroPeleador from '@/components/Evento-Julio/Peleadores/RegistroPeleador.vue'
import RegistroAsistente from '@/components/Evento-Julio/Peleadores/RegistroAsistente.vue'
import SeleccionPeleador from '@/components/Evento-Julio/Peleadores/SeleccionPeleador.vue'
import StreamingLogin   from '@/components/Evento-Julio/Streaming/StreamingLogin.vue'
import StreamingEvento  from '@/components/Evento-Julio/Streaming/StreamingEvento.vue'
import LoginEscaner from '@/components/Evento-Julio/Escaner/LoginEscaner.vue'
import EscanerQR    from '@/components/Evento-Julio/Escaner/EscanerQR.vue'

// Dashboard Evento Julio
import LoginDashboard    from '@/components/DashboardEvento/LoginDashboard.vue'
import AdminGeneral      from '@/components/DashboardEvento/AdminDashbaord.vue'
import CrudBoletos       from '@/components/DashboardEvento/views/CrudBoletos.vue'
import CrudPatrocionadores from '@/components/DashboardEvento/views/CrudPatrocionadores.vue'
import CrudEvento        from '@/components/DashboardEvento/views/CrudEvento.vue'
import CrudInscripciones from '@/components/DashboardEvento/views/CrudInscripciones.vue'
import CrudPeleador      from '@/components/DashboardEvento/views/CrudPeleador.vue'
import CrudAsistentes    from '@/components/DashboardEvento/views/CrudAsistentes.vue'
import ResumenEvento     from '@/components/DashboardEvento/views/ResumenEvento.vue'


const routes = [
  // ── Públicas ───────────────────────────────────────────────────────────
  { path: '/',                         name: 'Landing',             component: LandingPage },
  { path: '/registro-peleador-torneo', name: 'RegistroPeleadorTour',component: RegistroPeleadorTour },
  { path: '/torneo',                   name: 'TorneoBrackets',      component: TorneoBrackets },
  { path: '/boletos',                  name: 'Boletos',             component: Boletos },
  { path: '/categorias',               name: 'Categorias',          component: Categorias },
  { path: '/informacion',              name: 'Informacion',         component: Informacion,    props: true },
  { path: '/peleadores',               name: 'Peleadores',          component: Peleadores,     props: true },
  { path: '/patrocinadores',           name: 'Patrocinadores',      component: Patrocinadores, props: true },
  { path: '/contacto',                 name: 'Contacto',            component: Contacto,       props: true },

  // ── Evento ─────────────────────────────────────────────────────────────
  { path: '/comprar-boletos',  name: 'Comprar-Boletos',  component: ComprarBoletos },
  { path: '/registro-peleador',name: 'RegistroPeleador', component: RegistroPeleador },
  { path: '/registro-asistente',name: 'RegistroAsistente', component: RegistroAsistente },

  { path: '/escaner/login',name: 'LoginEscaner',component: LoginEscaner,meta: { escanerGuestOnly: true }},
  { path: '/escaner',name: 'EscanerQR',component: EscanerQR},

  // ── Registro de invitados ──────────────────────────────────────────────
  {
    path: '/asignar-boleto/:token',
    name: 'AsignarBoleto',
    component: BoletoAsignado,
    props: true,
  },
  {
    path: '/asignar-boleto-streaming/:token',
    name: 'AsignarBoletoStreaming',
    component: BoletoAsignado,  // mismo componente, el back detecta que es streaming
    props: true,
  },

  // ── Campaña: selección de peleador pendiente (backfill histórico) ─────
  {
    path: '/seleccionar-peleador/:token',
    name: 'SeleccionPeleador',
    component: SeleccionPeleador,
    props: true,
  },

  // ── Streaming ─────────────────────────────────────────────────────────
  {
    path: '/streaming',
    name: 'StreamingLogin',
    component: StreamingLogin,
    meta: { streamingGuestOnly: true },  // si ya tiene jti, redirigir al evento
  },
  {
    path: '/evento-en-vivo',
    name: 'StreamingEvento',
    component: StreamingEvento,
    meta: { requiresStreamingAuth: true },  // guard propio para streaming
  },

  // ── Juez ──────────────────────────────────────────────────────────────
  {
    path: '/evento/login',
    name: 'EventoLogin',
    component: LoginJueces,
    meta: { guestOnly: true },
  },
  {
    path: '/evento/tatami/:id',
    name: 'TatamiView',
    component: TatamiView,
    meta: { requiresAuth: true },
  },

  // ── Pantallas públicas evento ──────────────────────────────────────────
  {
    path: '/evento/proximas-peleas',
    component: ProximaPeleaEnVivo,
    meta: { layout: 'blank' },
  },
  {
    path: '/evento/tatami/:tatamiId/pantalla',
    component: PantallaTatami,
    meta: { layout: 'blank' },
  },

  // ── Dashboard Evento Julio ─────────────────────────────────────────────
  {
    path: '/dashboard/login',
    name: 'DashboardLogin',
    component: LoginDashboard,
    meta: { dashboardGuestOnly: true },
  },
  {
    path: '/dashboard',
    component: AdminGeneral,
    meta: { requiresDashboardAuth: true },
    children: [
      { path: '',              name: 'DashboardResumen',  component: ResumenEvento     },
      { path: 'evento',        name: 'CrudEvento',        component: CrudEvento        },
      { path: 'peleadores',    name: 'CrudPeleador',      component: CrudPeleador      },
      { path: 'asistentes',    name: 'CrudAsistentes',    component: CrudAsistentes    },
      { path: 'inscripciones', name: 'CrudInscripciones', component: CrudInscripciones },
      { path: 'boletos',       name: 'CrudBoletos',       component: CrudBoletos       },
      { path: 'patrocinadores',name: 'CrudPatrocionadores',component: CrudPatrocionadores},
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const tokenJuez      = localStorage.getItem('evento_token')
  const tokenAdmin     = localStorage.getItem('admin_token')
  const streamingJti   = localStorage.getItem('streaming_jti')
  const staffAccess = localStorage.getItem('staff_access')

  // ── Guard streaming ────────────────────────────────────────────────────
  // Requiere jti de streaming para entrar al evento en vivo
  if (to.meta.requiresStreamingAuth && !streamingJti) {
    return next({ name: 'StreamingLogin' })
  }
  // Si ya tiene sesión de streaming, no mostrar el login de nuevo
  if (to.meta.streamingGuestOnly && streamingJti) {
    return next({ name: 'StreamingEvento' })
  }

  // ── Guard juez ─────────────────────────────────────────────────────────
  if (to.meta.requiresAuth && !tokenJuez) {
    return next({ name: 'EventoLogin' })
  }
  if (to.meta.guestOnly && tokenJuez) {
    return next({ name: 'TatamiView', params: { id: 1 } })
  }

  // ── Guard dashboard admin ──────────────────────────────────────────────
  if (to.meta.requiresDashboardAuth && !tokenAdmin) {
    return next({ name: 'DashboardLogin' })
  }
  if (to.meta.dashboardGuestOnly && tokenAdmin) {
    return next({ name: 'DashboardResumen' })
  }

  if (to.meta.requiresEscanerAuth && !staffAccess) {
    return next({ name: 'LoginEscaner' })
  }
  if (to.meta.escanerGuestOnly && staffAccess) {
    return next({ name: 'EscanerQR' })
  }

  next()
})

router.afterEach(() => {
  setTimeout(() => AOS.refresh(), 0)
})

export default router